import React, { useState, useEffect  } from 'react';
import * as ReactGA from 'react-ga';
import { useSelector} from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './AuthElement.css';
import c from 'classnames';
import {
  UserState,
  selectUsername,
} from '../../ducks';
import { ClickElement } from '../form';
import { Loading } from '../loading';
import { userLogout } from '../../apis/user';
import { useAuthCheck } from './hooks';

export const AuthElement = ({ history, showLabel }) => {

  const username = useSelector(selectUsername);
  const [userState, isLoggedIn] = useAuthCheck();
  const [showAuthDropdown, setShowAuthDropdown] = useState(false);
  const currentLocation = history.location.pathname + history.location.search;

  const loginProps = isLoggedIn 
    ? { 
      ElementType: 'div',
      onClick: () => setShowAuthDropdown(!showAuthDropdown),
    } 
    : {
      ElementType: Link,
      type: 'button',
      to: {
        pathname: '/login', state: { prevLocation: currentLocation },
      },
    }; 

  const GAEvent = event => {
    ReactGA.event({
      category: 'user',
      ...event,
    });
  };

  const userName = () => <div className={styles.username}><span>{username}</span></div>;

  const LoggedInLabel = () => 
    <>
      {UserState.PENDING === userState && <Loading extraSmallLoader showSuffix={false}/>}
      {UserState.CHECKED === userState && <>
        <FontAwesomeIcon icon="user" size="lg" color={isLoggedIn ? 'var(--color-brand)' : null }/>
        {showLabel && <>&nbsp;{isLoggedIn ? userName() :'inloggen'}</>}
      </>}
    </>;

  useEffect(() => {
    if (UserState.CHECKED === userState && isLoggedIn && currentLocation !== '/login') {
      GAEvent({
        action: 'Logged-in',
        label: currentLocation,
      });
    }
  }, [userState, isLoggedIn]);

  return(
    <div className={styles.dropdown}>
      <ClickElement
        tertiary
        text={LoggedInLabel()}
        {...loginProps}
      />
      {isLoggedIn &&  
      <div className={c(styles['dropdown-content'], {
        [styles.show]: showAuthDropdown,
      })}>
        <div className={styles['container']}>
          <div 
            className={styles.close}
            onClick={() => setShowAuthDropdown(!showAuthDropdown)}
          >
            <FontAwesomeIcon icon="times" size="lg" />
          </div>
          ingelogd als:<br/>{userName()}
          <ClickElement
            tertiary
            ElementType="a"
            type="button"
            text='uitloggen'
            href={userLogout(true)}
            onClick={() => GAEvent({
              action: 'Logs out',
              label: 'Header',
            })}
            rel="noopener noreferrer"
          />
        </div>
      </div>
      }
    </div>
  );
};
